import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

import { useUIStore } from "@/stores/uiStore";

export function HeadConfig() {
  const title = useUIStore((state) => state.pageTitle);
  const { t } = useTranslation("common");

  return (
    <Helmet>
      <title>
        {title ? `${t("page_title")} - ${t(title)}` : t("page_title")}
      </title>
      <meta name={"description"} content={t("page_description")} />
      <meta name={"keywords"} content={t("page_keywords")} />
      <meta name={"author"} content={t("page_author")} />
    </Helmet>
  );
}
